import { TRoute } from "@/core/types/TRoute.ts";
// import { PermissionLevel } from "@/_apiSchema.ts";

export const headerRoutes: TRoute[] = [
    {
        path: "/homepage",
        title: "Startseite",
    },
    {
        path: "/reports",
        title: "Prüfberichte",
        teaser: {
            imageUrl: "assets/images/photo/berichtsverwaltung.jpg",
            actionLabel: "Berichte suchen",
            text: "In der Prüfberichte finden Sie einen Überblick über Ihre Prüfberichtsergebnisse und Auswertungen.",
        },
    },
];

export const homeRoute = headerRoutes[0];
